<template>
  <div>
    <popup-edit-group ref="popupEditGroup" />
    <div class="flex justify-between p-3">
      <p>
        Stock categories are used to group stock products together. This can be
        used when defining stock products.
      </p>
      <div class="flex justify-end">
        <vs-button
          v-if="!hasSelectedCategory"
          icon="add"
          @click="$refs.popupEditGroup.show()"
          type="relief"
          color="primary"
          class="mr-3"
          >Add category</vs-button
        >
        <vs-button
          v-else
          icon="add"
          @click="$refs.popupEditGroup.show(null, selectedCategoryId)"
          type="relief"
          color="primary"
          class="mr-3"
          >Add group</vs-button
        >
      </div>
    </div>

    <vs-row v-if="hasSelectedCategory">
      <vs-button class="mb-4" @click="deselectCategory">Go back</vs-button>
    </vs-row>

    <!-- Sales groups -->

    <draggable
      v-if="hasSelectedCategory"
      tag="ul"
      class="draggable-list grid grid-cols-4 gap-3"
      ghost-class="moving-card"
      filter=".action-button"
      :list="selectedGroups"
      :animation="200"
    >
      <div
        v-for="sg in selectedGroups"
        :key="sg.stockProductGroupId.id"
        :style="`background-color: ${sg.color}`"
        class="relative rounded-lg flex items-center justify-center h-24"
      >
        <h4 class="text-white text-center">{{ sg.name }}</h4>
        <div class="absolute top-0 right-0 m-2 flex">
          <feather-icon
            icon="EditIcon"
            @click.stop="$refs.popupEditGroup.show(sg, selectedCategoryId)"
            class="text-white h-5 w-5 cursor-pointer"
          />
          <feather-icon
            icon="TrashIcon"
            @click.stop="confirmDelete(sg.stockProductGroupId.id)"
            class="text-white ml-3 h-5 w-5 cursor-pointer"
          />
        </div>
      </div>
    </draggable>

    <draggable
      v-else
      tag="ul"
      class="draggable-list grid grid-cols-4 gap-3"
      ghost-class="moving-card"
      filter=".action-button"
      :list="stockCategories"
      :animation="200"
    >
      <div
        v-for="sg in stockCategories"
        :key="sg.productCategoryId.id"
        :style="`background-color: ${sg.color}`"
        class="relative rounded-lg cursor-pointer flex items-center justify-center h-24"
        @click="selectCategory(sg.productCategoryId.id)"
      >
        <h4 class="text-white text-center">{{ sg.name }}</h4>
        <div class="absolute top-0 right-0 m-2 flex">
          <feather-icon
            icon="EditIcon"
            @click.stop="$refs.popupEditGroup.show(sg)"
            class="text-white h-5 w-5 cursor-pointer"
          />
          <feather-icon
            icon="TrashIcon"
            @click.stop="confirmDelete(sg.productCategoryId.id)"
            class="text-white ml-3 h-5 w-5 cursor-pointer"
          />
        </div>
      </div>
    </draggable>

    <!-- Save button -->
    <vs-row>
      <vs-button
        v-if="!hasSelectedCategory"
        @click="saveChanges"
        id="save-button"
        class="mt-4"
        >Save Changes</vs-button
      >
    </vs-row>
  </div>
</template>

<script>
import popupEditGroup from "./PopupEditStockCategory";
import { mapGetters } from "vuex";
import Draggable from "vuedraggable";
export default {
  components: {
    popupEditGroup,
    Draggable,
  },
  data() {
    return {
      removeId: "",
      selectedCategoryId: null,
    };
  },
  methods: {
    deselectCategory() {
      this.selectedCategoryId = null;
    },
    selectCategory(id) {
      console.log(id);
      this.selectedCategoryId = id;
    },
    async saveChanges() {
      this.$vs.loading();
      await this.$store.dispatch("pos/countrySettings/updateCountrySettings");
      this.$vs.loading.close();
    },
    async confirmDelete(id) {
      this.removeId = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this group?",
        accept: this.remove,
      });
    },
    async remove() {
      // this.$vs.loading();
      // await this.$store.dispatch("pos/venues/deleteLocation", {
      //   venueId: this.venue.id,
      //   locationId: this.removeId,
      // });
      // this.$vs.loading.close();
      if (!this.hasSelectedCategory) {
        this.$store.commit("pos/countrySettings/deleteStockCategory", {
          productCategoryId: this.removeId,
        });
      } else {
        this.$store.commit("pos/countrySettings/deleteStockGroup", {
          productCategoryId: this.selectedCategoryId,
          stockProductGroupId: this.removeId,
        });
      }
    },
    async editLocation(location) {
      this.$refs.popupEditLocation.show(location);
    },
  },
  computed: {
    ...mapGetters({
      stockCategories: "pos/countrySettings/stockCategories",
    }),
    selectedGroups() {
      return this.stockCategories.find(
        (sg) => sg.productCategoryId.id === this.selectedCategoryId
      ).validProductGroups;
    },
    hasSelectedCategory() {
      return this.selectedCategoryId !== null;
    },
  },

  async mounted() {},
};
</script>

<style>
.moving-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px dashed #4299e1;
}
</style>
<style lang="scss" scoped>
.role-table {
  max-height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.rolecard {
  &.deactivated {
    opacity: 0.75;
  }

  min-width: 380px;
  max-width: 380px;

  .con-vs-card {
    border: 2px solid #ccc;
  }

  .vs-card--content {
    margin-bottom: 0;
  }

  .vs-card--footer {
    padding: 6px 12px;
    margin-top: 0;
    transform: none;
    background-color: #ccc;
    font-size: 0.8rem;
  }
}
</style>